module.exports = __webpack_public_path__ + "static/media/twitter.54c050a7.svg";